import {TestIdProps} from 'shared/web';

import {FeaturesFilterFieldBody} from '../../FeaturesFilterField/FeaturesFilterFieldBody';
import {useFeaturesFilterFieldState} from '../../FeaturesFilterField/hooks/useFeaturesFilterFieldState';

export interface PresetFeaturesFieldContentProps extends TestIdProps {
  features: string[];
  onFeaturesChange: (value: string[]) => void;
  isReadOnly?: boolean;
}

export function PresetFeaturesFieldContent(props: PresetFeaturesFieldContentProps) {
  const {features, onFeaturesChange, isReadOnly, 'data-testid': dataTestId} = props;

  const fieldState = useFeaturesFilterFieldState({
    features,
    onFeaturesChange,
    isInteractionDisabled: isReadOnly,
  });

  return <FeaturesFilterFieldBody variant="stacked" {...fieldState} data-testid={dataTestId} />;
}
